import { config } from "@config";

const facebookID = config.FACEBOOK_APP_ID;

const social = {
  facebookID,
};

export default social;
